import {StoreType} from '../../../types/sharedTypes';

export const userStoreMapParamsSelector = (state: StoreType) => {
  return state.userStoreMapReducer.params;
}

export const allUserStoreMapsSelector = (state: StoreType) => {
  return state.userStoreMapReducer.userStoreMapsResult;
}
